const xandr = require('./module');

/**
 * @module xandr
 */
window.advert = window.advert || {};
window.advert.modules = window.advert.modules || [];
window.advert.modules.push(['xandr', xandr]);
